import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { therapyPlanningAction } from '../../actions/constant';
import therapyPlanningService from '../../../services/apiServices/therapyPlanning/therapyPlanning';

const {
  GET_CPT_CODE_BY_DISCIPLINE_REQUEST,
  GET_CPT_CODE_BY_DISCIPLINE_SUCCESS,
  GET_CPT_CODE_BY_DISCIPLINE_FAILURE,
  GET_CPT_CODE_BY_DISCIPLINE_LOADER,
  GET_CPT_CODE_BY_DISCIPLINE_RESET,
} = therapyPlanningAction;

function* getCPTCodeByDiscipline(payload: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_CPT_CODE_BY_DISCIPLINE_LOADER });
    const response = yield call(therapyPlanningService.getCptCodeByDiscipline, payload?.payload);
    if (response?.status === 200) {
      yield put({ type: GET_CPT_CODE_BY_DISCIPLINE_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_CPT_CODE_BY_DISCIPLINE_FAILURE, payload: error });
  }
}

function* getCPTCodeByDisciplineSaga() {
  yield takeEvery(GET_CPT_CODE_BY_DISCIPLINE_REQUEST, getCPTCodeByDiscipline);
}

export default getCPTCodeByDisciplineSaga;
